import React from 'react';
import { usePagination } from './usePagination';

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    currentPage,
    pageSize,
    className
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    pageSize
  });

  // If there's only one page (or no items), hide the pagination buttons but show the info
  const hidePaginationButtons = totalCount <= pageSize;

  const onNext = () => {
    if (currentPage < paginationRange[paginationRange.length - 1]) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const startItemIndex = (currentPage - 1) * pageSize + 1;
  const endItemIndex = Math.min(currentPage * pageSize, totalCount);

  return (
    <ul className={`pagination-container ${className || ''}`}>
      {/* Item Range Display */}
      <li className="pagination-item range-display">
        {startItemIndex}-{endItemIndex} of {totalCount}
      </li>

      {!hidePaginationButtons && (
        <>
          {/* Left Arrow */}
          <li
            className={`pagination-item arrow-button ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={onPrevious}
          >
            <span className="arrow">&#x2190;</span>
          </li>

          {/* Current Page Number */}
          <li className="pagination-item selected">
            {currentPage}
          </li>

          {/* Right Arrow */}
          <li
            className={`pagination-item arrow-button ${currentPage === paginationRange[paginationRange.length - 1] ? 'disabled' : ''}`}
            onClick={onNext}
          >
            <span className="arrow">&#x2192;</span>
          </li>
        </>
      )}
    </ul>
  );
};

export default Pagination;